import * as React from 'react';
import { SVGProps } from 'react';

function SvgNavigateback(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      data-name="navigate back"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        data-name="\u21B3Color"
        d="M15.4 7.41 13.992 6 8 12l5.992 6 1.408-1.41L10.826 12Z"
      />
    </svg>
  );
}

export default SvgNavigateback;
